<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Purchase Order</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button
              @click="editPurchaseOrder"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            > -->
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />
        <div class="vx-row p-5" v-if="purchaseOrderDescription.company_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Client:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.company_name }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="purchaseOrderDescription.po_number">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              PO Number:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.po_number }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="purchaseOrderDescription.total_po_value">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Total PO  Value:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.total_po_value }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="purchaseOrderDescription.used_po_value">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Used PO Value:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.used_po_value }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="purchaseOrderDescription.remaining_po_value">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Remaining PO Value:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.remaining_po_value }}
          </div>
        </div>
           
        <div class="vx-row p-5" v-if="purchaseOrderDescription.po_allocation">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             PO Allocation:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.po_allocation }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="purchaseOrderDescription.raised_date">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             Raised Date:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.raised_date }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="purchaseOrderDescription.po_status">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             PO Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ purchaseOrderDescription.po_status }}
          </div>
        </div>

        <div class="text-center p-5">
          <h5>Allocated Purchase Order</h5>

        </div>

        <vs-table stripe :data="POAssociatedCampaigns">
        <template slot="thead">
          <vs-th>Campaign Code </vs-th>
          <vs-th>Campaign Name </vs-th>
          <vs-th>Allocated Value</vs-th>
          <vs-th>Allocated On</vs-th>

        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].campaign_code">
              {{ data[indextr].campaign_code }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_name">
              {{ data[indextr].campaign_name }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_po_value_allocated">
              {{ data[indextr].campaign_po_value_allocated }}
            </vs-td>
            <vs-td :data="data[indextr].allocated_on">
              {{ data[indextr].allocated_on }}
            </vs-td>
       
          </vs-tr>
        </template>
      </vs-table>

      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moment from "moment";
import modulePurchaseOrdersManagement from "@/store/campaign-management/purchase-orders-management/modulePurchaseOrdersManagement.js";
import vSelect from "vue-select";
export default {
  data() {

    return {
      configDateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      POAssociatedCampaigns: [],
      abilities: null,
      purchaseOrderDescription: [],
      purchaseOrderId: null
    };
  },
  components: {
    "v-select": vSelect,
    modulePurchaseOrdersManagement,
        flatPickr

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!modulePurchaseOrdersManagement.isRegistered) {
      this.$store.registerModule(
        "PurchaseOrdersManagement",
        modulePurchaseOrdersManagement
      );
      modulePurchaseOrdersManagement.isRegistered = true;
    }
  },
  mounted() {
    this.purchaseOrderId = this.$route.params.purchaseOrderId;
    this.fetchPurchaseOrder();
  },
  methods: {
    fetchCampaignAssociatedPO() {
      this.$store
        .dispatch("PurchaseOrdersManagement/fetchCampaignAssociatedPO", this.purchaseOrderId)
        .then(res => {
          this.POAssociatedCampaigns = JSON.parse(res.data);

          this.POAssociatedCampaigns.forEach(ele => ele.allocated_on = moment(ele.allocated_on).format('YYYY-MM-DD'))

          console.log(this.POAssociatedCampaigns)
        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    fetchPurchaseOrder() {
      this.$store
        .dispatch("PurchaseOrdersManagement/fetchPurchaseOrders", this.purchaseOrderId)
        .then(res => {
          this.purchaseOrderDescription = JSON.parse(res.data)
          if(this.purchaseOrderDescription){
            this.purchaseOrderDescription.raised_date = moment(this.purchaseOrderDescription.raised_date).format('YYYY-MM-DD')
          }

          this.fetchCampaignAssociatedPO()


        })
        .catch(err => {
          console.error(err);
        });
    },
    editPurchaseOrder() {
      this.$router.push({ path: `/fields/purchase-order/edit/${this.purchaseOrderId}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
